import React, {useEffect, useMemo, useState} from 'react'
import * as PropTypes from 'prop-types'
import {InferPropTypes} from '@modifi/typescript-utils'

import {Container} from './styles'

const propTypes = {
  scrollOffset: PropTypes.number,
  isSwiping: PropTypes.bool.isRequired,
  children: PropTypes.node,
  swipeable: PropTypes.bool,
}
const defaultProps = {
  children: null,
  scrollOffset: undefined,
  swipeable: false,
}

export type CarouselInnerProps = InferPropTypes<typeof propTypes, typeof defaultProps>

const CarouselInner: React.FC<CarouselInnerProps> = ({
  scrollOffset,
  isSwiping,
  swipeable,
  children,
}) => {
  const [doTransitions, setDoTransitions] = useState(false)

  useEffect(() => {
    if (typeof scrollOffset !== 'undefined') {
      setDoTransitions(true)
    }
  }, [scrollOffset])

  return (
    <Container
      isSwiping={isSwiping}
      swipeable={swipeable}
      doTransitions={doTransitions}
      style={{transform: `translateX(${(scrollOffset ?? 0) * -1}px)`}}
    >
      {useMemo(() => children, [children])}
    </Container>
  )
}

CarouselInner.propTypes = propTypes
CarouselInner.defaultProps = defaultProps

export default CarouselInner
